import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { TandemCoreModule } from '../tandem-core/tandem-core.module';
import { FinancialOverviewComponent } from './components/financial-overview/financial-overview.component';
import { TrackMyProgressComponent } from './components/track-my-progress/track-my-progress.component';
import { GoalsComponent } from './components/goals/goals.component';
import {GoalCardComponent} from "./components/goal-card/goal-card.component";
import {ReactiveFormsModule} from "@angular/forms";
import {FinancialPositionsModule} from "../financial-positions/financial-positions.module";
import {CashFlowsModule} from "../cash-flows/cash-flows.module";
import {SpendingPlansModule} from "../spending-plans/spending-plans.module";
import { GoalFormComponent } from './components/goal-form/goal-form.component';
import { VisionDialogComponent } from './components/vision-dialog/vision-dialog.component';
import {DialogModule} from "@angular/cdk/dialog";

@NgModule({
    declarations: [
        DashboardComponent,
        FinancialOverviewComponent,
        TrackMyProgressComponent,
        GoalsComponent,
        GoalCardComponent,
        GoalFormComponent,
        VisionDialogComponent,
    ],
    imports: [
        CommonModule,
        DashboardRoutingModule,
        TandemCoreModule,
        ReactiveFormsModule,
        FinancialPositionsModule,
        CashFlowsModule,
        SpendingPlansModule,
    ],
  providers: [
    DialogModule
  ],
    exports: [
        GoalsComponent
    ]
})
export class DashboardModule {}
